export default __webpack_public_path__ + "static/media/unicredit.8f7fddc4.png";